import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { formatDate, teamNameShort } from '../../lib/format';

const BoxScore = ({ game }) => {
  const gameDetails = useMemo(() => getGameDetail(game), [game]);

  const loading = game ? 'is-fade-loaded' : 'is-fade-loading';

  return (
    <div className={`boxscore ${loading}`}>
      <p className="boxscore__game-info">
        {gameDetails.league} · {gameDetails.stage} | {gameDetails.date}
      </p>

      <p className="boxscore__game-score">
        <span className="color-home" title={gameDetails.home.title}>
          {gameDetails.home.name}
        </span>{' '}
        {gameDetails.home.points} - {gameDetails.visitor.points}{' '}
        <span className="color-visitor" title={gameDetails.visitor.title}>
          {gameDetails.visitor.name}{' '}
        </span>
      </p>
    </div>
  );
};

BoxScore.propTypes = {
  team: PropTypes.object,
};

export default BoxScore;

const EMPTY = {
  home: { name: ' ' },
  visitor: { name: ' ' },
};

function getGameDetail(gameData) {
  if (!gameData || !gameData.home || !gameData.visitor) return EMPTY;
  return {
    home: {
      title: gameData.home.team.name,
      name: teamNameShort(gameData.home.team),
      points: gameData.home_points,
    },
    visitor: {
      title: gameData.visitor.team.name,
      name: teamNameShort(gameData.visitor.team),
      points: gameData.visitor_points,
    },
    date: formatDate(gameData.start_time),
    league: gameData.stage.league.name,
    stage: gameData.stage.name,
  };
}
